import { render } from "./dashboard_cotizaciones_simple.vue?vue&type=template&id=285bffd4&scoped=true"
import script from "./dashboard_cotizaciones_simple.vue?vue&type=script&lang=js"
export * from "./dashboard_cotizaciones_simple.vue?vue&type=script&lang=js"

import "./dashboard_cotizaciones_simple.vue?vue&type=style&index=0&id=285bffd4&scoped=true&lang=css"

import exportComponent from "D:\\Users\\felipecedillo\\Documents\\GitHub\\marbel-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-285bffd4"]])

export default __exports__